/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import { Card, Form, Button, Modal, InputGroup } from 'react-bootstrap';
import { useTheme } from '../../../../providers/theme';
// import {
//   PencilIcon,
//   MailIcon,
//   PhoneIcon,
//   DocumentAddIcon,
//   WifiIcon,
// } from "@heroicons/react/solid";
// import { ChoosePhotoWidget } from "@vlinder-web/choose-photo-widget-react";

export interface IUpdateGroupModel {
  showModal?: boolean;
  createModalLabel?: string;
  onAcknowledgement?(): void;
  onDeny?(): void;
}

export const UpdateModal = ({
  showModal,
  createModalLabel,
  onDeny,
  onAcknowledgement,
  defaultProfileImg,
}: IEditGroupModel) => {
  const [show, setShow] = useState(showModal);
  const theme = useTheme();
  //   const [profileImg, setProfileImg] = useState<any>(null);
  //   const nameRef = useRef(null);
  //   const contactRef = useRef(null);
  //   const addressRef = useRef(null);
  //   const websiteRef = useRef(null);
  //   const descriptionRef = useRef(null);

  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };

  //   const handlePhotoChosen = (file: any) => {
  //     setProfileImg(file?.base64);
  //   };

  //   const _onFormSubmit = (event: any) => {
  //     if (event) {
  //       event.preventDefault();
  //       if (onAcknowledgement) {
  //         onAcknowledgement(
  //           nameRef?.current?.value,
  //           descriptionRef?.current?.value,
  //           contactRef?.current?.value,
  //           addressRef?.current?.value,
  //           websiteRef?.current?.value,
  //           profileImg
  //         );
  //       }
  //       // 👇️ clear all input values in the form
  //       event.target.reset();
  //     }
  //     setShow(false);
  //   };
  const FIELDS: any = [
    {
      type: 'select',
      compProps: {
        id: 'idProofType',
        label: 'Select Id Proof Type',
        required: true,
        options: [
          {
            id: 'passport',
            label: 'Passport',
          },
          {
            id: 'socialSecurityCard',
            label: 'Social Security Card',
          },
          {
            id: 'nationalInsurance',
            label: 'National Insurance',
          },
          {
            id: 'driverLicense',
            label: "Driver's license",
          },
        ],
        errorText: 'Id Proof is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        id: 'idProof',
        label: 'Select Id Proof',
        required: true,
        maxFiles: 1,
        errorText: 'One Id Proof is required',
      },
    },
    {
      type: 'radio',
      compProps: {
        id: 'addressProofType',
        label: 'Select Address Proof Type',
        required: true,
        errorText: 'Address proof type is required',
        direction: 'horizontal',
        options: [
          {
            id: 'utilityBill',
            label: 'Utility Bill',
          },
          { id: 'bankstatement', label: 'Bank Statement' },
          { id: 'other', label: 'Other' },
        ],
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        id: 'addressProof',
        label: 'Upload Address Proof',
        required: true,
        maxFiles: 1,
        errorText: 'One Id Proof is required',
      },
    },
  ];
  const layout = [
    ['idProofType'],
    ['idProof'],
    ['addressProofType'],
    ['addressProof'],
  ];

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header className="border-0">
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Header className="text-center text-md-center border-0 mb-0 mt-md-0">
            <h4>{createModalLabel}</h4>
          </Card.Header>
          <Card.Body>
            <TweetyWidget
              labelColor={theme.colors.primary}
              fields={FIELDS}
              layout={layout}
              onFormSubmit={(payload) => console.log('payload =>', payload)}
            />
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

UpdateModal.defaultProps = {
  showModal: false,
  createModalLabel: 'Update KYC Form',
};
